export default __webpack_public_path__ + "static/1_27-178601d8c29447c60e8b27490b74c86d.png";